import { ReactNode, useEffect } from 'react'

import { Helmet } from 'react-helmet-async'
import { Navigate } from 'react-router-dom'

import { hasScopesPermission } from '@tribeplatform/gql-client/lib'
import { useLogin } from '@tribeplatform/react-components/common/hooks'
import { useRouterPath } from '@tribeplatform/react-sdk'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'

import { AdminMenu } from './AdminMenu/index.js'
import { useScroll } from './ScrollProvider.js'

const ScrollToTop = () => {
  const { scrollRef } = useScroll()
  const pathname = useRouterPath()

  useEffect(() => {
    const parentElement = scrollRef.current

    if (parentElement) {
      parentElement.scrollTo(0, 0)
    }
  }, [scrollRef, pathname])

  return null
}

export const AdminRouteGuard = ({ children }: { children: ReactNode }) => {
  const pathname = useRouterPath()
  const { data: network } = useNetwork()
  const [canUpdateNetwork] = hasScopesPermission(network, ['updateNetwork'])
  const { isLoggedIn, showLogin } = useLogin()

  useEffect(() => {
    if (!isLoggedIn) {
      showLogin()
    }
  }, [isLoggedIn, showLogin])

  if (!isLoggedIn) {
    return null
  }

  if (!canUpdateNetwork) {
    return <Navigate to="/" />
  }

  return (
    <AdminMenu>
      <Helmet
        bodyAttributes={{
          'data-path': pathname,
          'data-matched-route': `/manage`,
        }}
      />
      <ScrollToTop />
      {children}
    </AdminMenu>
  )
}
